import { FootnoteReferenceV2 } from '@oneaudi/feature-app-utils';
import { Footnote } from '@oneaudi/footnote-service/dist/cjs/types/footnotes-response.type';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useAppServices } from '~/app/contexts/app-context';
import { state } from '~/storage';
import { CAE_CONFIGUREDCAR_REMARK, CAE_REMARK } from '~/components/footnotes/constants';
import { useFootnotes } from '~/components/footnotes';

const ConsumptionFootnote = () => {
	const [consumptionDisclaimers] = useAtom(state.consumptionDisclaimersAtom);
	const footnoteContent = PrepareConsumptionFootnote(consumptionDisclaimers);

	const {
		featureServices: { footnoteService },
	} = useAppServices();

	useEffect(() => {
		if (footnoteContent) {
			const footnote = [{ Key: CAE_REMARK, Text: footnoteContent ?? '' } as Footnote];
			footnoteService?.replaceFootNotes(footnote);
		}
		return () => {
			footnoteService?.replaceFootNotes([
				{
					Key: CAE_REMARK,
					Text: '',
				},
			]);
		};
	}, [footnoteContent]);

	return <FootnoteReferenceV2 footnoteId={CAE_REMARK} />;
};

function PrepareConsumptionFootnote(disclaimers: string[]): string {
	if (!disclaimers || disclaimers.length < 1) return '';
	const regEx = new RegExp(/\{\{[^()]*\}\}/gm);
	const disclaimerText = disclaimers.reduce((acc, curr) => {
		return acc.replace(regEx, '') + ' | ' + curr.replace(regEx, '');
	});
	return disclaimerText;
}

export function RegisterOrUpdateConsumptionFootnoteForDialog(
	overrideDisclaimer?: string[],
	consumptionDisclaimerIdentifier?: string,
): void {
	const { registerFootnote, getReference, updateFootnote } = useFootnotes();
	const [consumptionDisclaimers] = useAtom(state.consumptionDisclaimersConfiguredCarAtom);
	const disclaimer = PrepareConsumptionFootnote(overrideDisclaimer || consumptionDisclaimers);
	const disclaimerIdentifier = consumptionDisclaimerIdentifier || CAE_CONFIGUREDCAR_REMARK;

	registerFootnote(disclaimerIdentifier, disclaimer);

	const existingFootnoteReference = getReference(disclaimerIdentifier);

	if (existingFootnoteReference && existingFootnoteReference !== '') {
		updateFootnote(disclaimerIdentifier, disclaimer);
	}
}

export default ConsumptionFootnote;
